<template>
  <div class="patient-manage" v-if="showPage">
    <van-cell-group inset>
        <!-- <van-cell title="选择患者绑定关系" :value="choose_content" @click="onChoose()" is-link/> -->
        <van-cell title="选择患者状态" :value="choose_content" @click="showPicker = true" is-link/>
    </van-cell-group>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns"  @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
    <div class="patient_list">
        <van-search v-model="searchValue" @search="onSearch" left-icon show-action placeholder="搜索患者名/手机号" >
            <template #action>
            <div @click="onSearch"><van-icon name="search" size='20' /></div>
            </template>
        </van-search>
        <van-list v-model="loading" :finished="finished" @load="onLoad" offset="50">
            <van-cell v-for="item,index in list" :key="index" is-link  @click="gopatientDetial(item)">
                 <template #title>
                    <div class="patient_info">
                      <div class="patient-id"><div class="up-layer">{{item.id}}</div></div>
                      <div class="">
                          <div>{{item.name}}/{{item.mobile.substring(0,4)}}****{{item.mobile.substring(8,12)}}</div>
                          <div>状态:{{item.front_status}}</div>
                      </div>
                    </div>
                </template>
            </van-cell>
            <template #finished>
                <van-divider :style="{ color: '#bababa', borderColor: '#bababa', padding: '0 80px'}">
                    <div style="width:3px;height:3px;border-radius:100%;background-color:#bababa;"></div>
                </van-divider>
            </template>
        </van-list>
        <div class="add_btn">
          <van-button type="primary" color="#0AA8AF" @click="addPatient()" block>新增患者</van-button>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List,Toast,Divider} from 'vant';
import { mapState } from "vuex";
import { getPatientStatusList } from '@/api/publicWelfareStaff';

Vue.use(Divider);
Vue.use(List);
Vue.use(Toast);
export default {
    data(){
        return {
          showPage:false,
          choose_content: "全部",
          showPicker: false, 
          columns: [
              '全部','待完善资料（人脸和知情未完成）','入组审核申请（材料未上传）','入组审核申请（材料已上传)','入组审核申请（材料未通过）',
              '纸质材料待邮寄','纸质材料审核不通过重新邮寄','申请领药（材料未上传）','申请领药（材料已上传）','申请领药（材料未通过）',
              '领药前人脸识别（人脸识别未上传）','领药前人脸识别（人脸识别已上传）','领药前人脸识别（人脸识别未通过）','待领药','本阶段援助结束',
              '解锁材料上传（材料未上传）','解锁材料上传（材料已上传）','解锁材料上传（材料未通过）','阶段审核申请（材料未上传）',
              '阶段审核申请（材料已上传）','阶段审核申请（材料未通过）','出组'
          ],
          searchValue: '',
            
            //无限加载列表
            list: [],
            loading: false,
            finished: false,
            page:1,
        }
    },
    computed: {
        ...mapState(['publicWelfareStaff']),
    },
    async created(){
      await this.init()
      this.showPage=true;
    },
    methods: {
      async init(){
        const {
          city,
          messageCount,
          statusing_list,
          volunteer
        }=this.publicWelfareStaff.volunteer_info
        this.columns=statusing_list
        if(this.columns[0]!="全部") this.columns.unshift("全部")
        // this.fetchData(this.searchValue,this.choose_content,this.page)
      },
      async fetchData(keyword,patient_status,page){
        let data=[]
        let sendData={
          keyword:keyword,
          patient_status:patient_status,
          page:page,
          volunteer_id:this.publicWelfareStaff.checkin_info.papid
        }
        if(patient_status=='全部') delete sendData.patient_status
        if(!keyword) delete sendData.keyword
        await getPatientStatusList(sendData).then(res=>{
          console.log("getPatientStatusList",res)
          this.list=[...this.list,...res.data]
          data=res.data
        }).catch(error=>{
          Toast(err.response.data.message)
        })
        return data
      },
      async onConfirm(value){
        Toast.loading({
            duration: 0, // 持续展示 toast
            overlay: true,
            forbidClick: true
        });
        this.choose_content = value;
        this.showPicker = false;
        this.list=[]
        this.page=1
        await this.fetchData(this.searchValue,this.choose_content,this.page)
        this.page++
        this.finished = false;
        Toast.clear();
      },
      async onSearch(value){
        Toast.loading({
            duration: 0, // 持续展示 toast
            overlay: true,
            forbidClick: true
        });
        console.log("搜索的值",value)
        this.list=[]
        this.page=1
        await this.fetchData(this.searchValue,this.choose_content,this.page)
        this.page++
        this.finished = false;
        Toast.clear();
      },
      async onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        // setTimeout(() => {
            await this.fetchData(this.searchValue,this.choose_content,this.page).then(res=>{
              console.log("fetchData",res)
              if (res.length>0) this.page++

              // 加载状态结束
              this.loading = false;

              // 数据全部加载完成
              if (res.length==0) {
                  this.finished = true;
              }
            })


        // }, 1000);
      },
      gopatientDetial(item){
        this.$router.push({
          name:'patientDetial',
          query:{
            papid:item.id,
            name:item.name,
            mobile: item.mobile,
            front_status:item.front_status, 
            // patient_id:item.patient_id,
          }
        })
      },
      addPatient(){
        // 新增患者
        console.log("新增患者")
        this.$router.push({name:'patientOcr'})
      }
    }
}
</script>

<style lang="scss" scoped>
.patient-manage{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    padding-top:15px;
    font-size: 16px;
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .patient_list{
      margin-top: 18px;
      box-shadow: 0 -2px 6px rgba(204, 204, 204, 0.2);
      padding-bottom: 44px;
      .patient_info{
        display: flex;
        .patient-id{
            width: 40px;
            height: 40px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            box-shadow: 0 0 3px  3px rgba(0, 0, 0, 0.01);
            border-radius: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 10px;
            .up-layer{
              color:white;
              font-weight:bold;
              width: 34px;
              height: 34px;
              background-color: #8ddbdf;
              // padding:5px;
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
        }
      }
      .add_btn{
        position:fixed;
        bottom:0;
        width:100%;
      }
      
    }
}
</style>